var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PaymentPageErrorView"},[_c('el-row',{attrs:{"justify":'center',"align":'middle',"type":"flex"}},[_c('el-col',{attrs:{"sm":13}},[_c('MessageInfo',{attrs:{"messageType":_vm.errorMessage.type,"title":_vm.errorMessage.title,"code":_vm.errorMessage.code,"description":_vm.errorMessage.description}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783d35c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PaymentErrorPage.vue
// module id = 393
// module chunks = 2